import React from "react";
import { Dropdown } from "react-bootstrap";

const DashboardFilterSelect = ({ children, value, onChange, className, style, ...props }) => {
  const options = React.Children.toArray(children).filter((child) => React.isValidElement(child) && child.type === "option");
  const selected = options.find((option) => String(option.props.value) === String(value));
  return (
    <Dropdown className="dashboard-filter-dropdown" style={{ width: style?.width }}>
      <Dropdown.Toggle
        variant=""
        className="dashboard-filter-trigger"
        aria-label={props["aria-label"] || "Filter report"}
        disabled={props.disabled}
      >
        <span>{selected?.props.children || "Select Date"}</span>
        <i className="fa-solid fa-chevron-down" aria-hidden="true" />
      </Dropdown.Toggle>
      <Dropdown.Menu className="dashboard-filter-menu" role="menu">
        {options.map((option) => (
          <Dropdown.Item
            key={option.props.value}
            role="menuitemradio"
            aria-checked={option === selected}
            active={option === selected}
            disabled={option.props.disabled}
            onClick={() => onChange?.({ target: { value: option.props.value } })}
          >
            <span>{option.props.children}</span>
            {option === selected && <i className="fa-solid fa-check" aria-hidden="true" />}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default DashboardFilterSelect;
